export const SET_PURCHASERECONCILIATION = "SET_PURCHASERECONCILIATION" 
export const SET_CHANGESTATE_LIST_TYPE_STATE = "SET_CHANGESTATE_LIST_TYPE_STATE"